import { slicedToArray as _slicedToArray, extends as _extends, objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from './_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useContext } from 'react';
import { CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';
import { useTranslate } from '@awardit/react-use-translate';
import { StripeContext } from './context.js';

var defaultOptions = {
  style: {
    base: {
      color: "#222",
      letterSpacing: "0.025em",
      fontSize: "16px",
      "::placeholder": {
        color: "#555"
      }
    },
    invalid: {
      color: "#9e2146"
    }
  }
};
var StripeCardComponent = function StripeCardComponent(_ref) {
  var _ref$options = _ref.options,
    options = _ref$options === void 0 ? defaultOptions : _ref$options,
    processing = _ref.processing,
    disabled = _ref.disabled,
    styles = _ref.styles,
    Button = _ref.Button;
  var t = useTranslate();
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    fieldsFilled = _useState2[0],
    setFieldsFilled = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    dirty = _useState4[0],
    setDirty = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  var FIELDS = {
    cardNumber: "Card number missing",
    cardExpiry: "Card expiry date missing",
    cardCvc: "Card CVC missing"
  };
  var onChange = function onChange(e) {
    if (e.error) {
      return setError({
        type: [e.elementType],
        msg: e.error.message
      });
    }
    if (e.empty) {
      setFieldsFilled(_objectSpread2(_objectSpread2({}, fieldsFilled), {}, _defineProperty({}, e.elementType, false)));
    } else {
      setFieldsFilled(_objectSpread2(_objectSpread2({}, fieldsFilled), {}, _defineProperty({}, e.elementType, true)));
      setError(null);
    }
  };
  var fieldEmptyError = Object.keys(FIELDS).map(function (f) {
    return !fieldsFilled[f] ? FIELDS[f] : null;
  }).find(function (x) {
    return x;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: styles.stripeBlock
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.stripeRow
  }, /*#__PURE__*/React.createElement("label", {
    className: styles.stripeLabel
  }, t("STRIPE.CARD_NUMBER"), /*#__PURE__*/React.createElement(CardNumberElement, _extends({}, options, {
    onChange: onChange
  })))), /*#__PURE__*/React.createElement("div", {
    className: styles.stripeRow
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.stripeSplit
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.stripeLeft
  }, /*#__PURE__*/React.createElement("label", {
    className: styles.stripeLabel
  }, t("STRIPE.MM/YY"), /*#__PURE__*/React.createElement(CardExpiryElement, _extends({}, options, {
    onChange: onChange
  })))), /*#__PURE__*/React.createElement("div", {
    className: styles.stripeRight
  }, /*#__PURE__*/React.createElement("label", {
    className: styles.stripeLabel
  }, t("STRIPE.CVC"), /*#__PURE__*/React.createElement(CardCvcElement, _extends({}, options, {
    onChange: onChange
  })))))), error && /*#__PURE__*/React.createElement("div", {
    className: styles.stripeError
  }, error.msg), dirty && fieldEmptyError && /*#__PURE__*/React.createElement("div", {
    className: styles.stripeError
  }, fieldEmptyError), /*#__PURE__*/React.createElement(Button, {
    className: styles.stripeButton,
    variant: "primary",
    loading: processing,
    disabled: processing || disabled,
    onClick: function onClick(e) {
      setDirty(true);
      if (error || fieldEmptyError) {
        e.preventDefault();
      }
    }
  }, processing ? t("STRIPE.PROCESSING") : t("CHECKOUT.PAY_WITH_CARD")));
};
var CustomPaymentRequestButton = function CustomPaymentRequestButton(_ref2) {
  var Button = _ref2.Button,
    styles = _ref2.styles,
    disabled = _ref2.disabled;
  var t = useTranslate();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    disabled: disabled,
    className: styles.button
  }, t("PAYMENT.USE_SAVED_CARD")));
};
var ApplePayButton = function ApplePayButton(_ref3) {
  var disabled = _ref3.disabled;
  return /*#__PURE__*/React.createElement("button", {
    lang: "en",
    "aria-label": "Apple Pay",
    role: "button",
    type: "submit",
    className: "apple-pay-button",
    style: {
      width: "100%",
      marginBottom: "1em"
    },
    disabled: disabled
  });
};
var StripeButtonComponent = function StripeButtonComponent(_ref4) {
  var processing = _ref4.processing,
    styles = _ref4.styles,
    disabled = _ref4.disabled,
    Button = _ref4.Button;
  var _useContext = useContext(StripeContext),
    browser = _useContext.browser,
    canMakeButtonPayment = _useContext.canMakeButtonPayment;
  if (!canMakeButtonPayment) {
    return null;
  }
  if (processing) {
    return /*#__PURE__*/React.createElement(Button, {
      loading: true,
      className: styles.stripeButton,
      variant: "primary"
    }, "\xA0");
  }
  return /*#__PURE__*/React.createElement("div", null, browser === "apple" ? /*#__PURE__*/React.createElement(ApplePayButton, {
    disabled: disabled
  }) : /*#__PURE__*/React.createElement(CustomPaymentRequestButton, {
    Button: Button,
    disabled: disabled,
    variant: "primary",
    browser: browser,
    styles: styles
  }));
};

export { StripeButtonComponent, StripeCardComponent };
//# sourceMappingURL=components.js.map
